/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import Amount, { AmountProps } from './transaction/Amount'

export type BudgetProps = Pick<AmountProps, 'withCurrency'> & {
  min?: number
  max?: number
}

function Budget (props: BudgetProps) {
  const { min, max, withCurrency } = props

  if (min && max) {
    return <>
      {'\u2265'}&nbsp;<Amount value={min} inherit span withCurrency={withCurrency} />
      <br />
      {'\u2264'}&nbsp;<Amount value={max} inherit span withCurrency={withCurrency} />
    </>
  }
  if (min) {
    return <>{'\u2265'}&nbsp;<Amount value={min} inherit span withCurrency={withCurrency} /></>
  }
  if (max) {
    return <>{'\u2264'}&nbsp;<Amount value={max} inherit span withCurrency={withCurrency} /></>
  }
  return null
}

export default Budget
